export default __webpack_public_path__ + "static/media/ava-12.b6741643.png";